import { useRef } from 'react';
import { useState, useEffect } from "react";
import cargandoCard from "../../components/cargando-card";
import SinAccesoCard from "../../components/sin-acceso-card";
import { useHistory } from "react-router-dom";
import { sharedNextPage } from "../../utils/shared-functions";
import Select from "react-select";
import html2pdf from 'html2pdf.js';
import moment from "moment";
import "react-widgets/styles.css";
import DatePicker from "react-widgets/DatePicker";
import momentLocalizer from "react-widgets-moment";
import { ESTILO_BOTON_LISTAR_NUEVO } from "../../utils/const/estilos-const";
import { obtenerTodasLasUnidades } from "../../api/gestion-dts/gestion";
import { obtenerDatosDashboardChecklist, obtenerDetalleRespuestaChecklist, obtenerFormularioChecklist, obtenerFormularioPieDePagina } from "../../api/api-checklist";
import shortid from "shortid";
import { Pie } from 'react-chartjs-2';
import {
    INT_TIPO_USUARIO_ADMINISTRADOR_WEB,
} from "../../utils/const/int-const";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { obtenerListaTipoOpcionesRespuesta } from "../../api/configuracion";
import { ExternalLink } from "feather-icons-react/build/IconComponents";
import ComponentDetalleChecklist from "../../components/component-detalle-checklist";
import { INT_PREGUNTA_SELECCION_SIMPLE } from "../../utils/const/tipo-pregunta-const";
import { PrinterIcon, ShareIcon } from "@heroicons/react/24/solid";
import { STRING_COLOR_PRIMARIO, STRING_ID_EMPRESA_CHECKLIST, STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST, STRING_TIPO_USUARIO_CHECKLIST } from '../../utils/const/string-const';
import { useTranslation } from "react-i18next";
import { COLOR_AZUL_MAIN } from '../../utils/const/colors-const';
import { obtenerPermisos } from '../../api/api-permisos';
import { PAGE_ID } from '../../utils/const/pages-const';
ChartJS.register(ArcElement, Tooltip, Legend);

// import { ExternalLink } from "feather-icons-react/build/IconComponents";
new momentLocalizer(moment);
/**
 * A basic printing example printing a component
 */

// let accesoBotonNuevo = 'none';

export default function DashboardScreen() {
    // const componentRef = React.useRef(null);

    const idTipoUsuario = localStorage.getItem(STRING_TIPO_USUARIO_CHECKLIST);
    const idSubTipoUsuarioWeb = localStorage.getItem(STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST);
    // console.log('idTipoUsuario', idTipoUsuario);
    // console.log('idSubTipoUsuarioWeb', idSubTipoUsuarioWeb);
    const pieRespuestasRef = useRef(null);
    const unidadesRef = useRef(null);
    const { t } = useTranslation();
    const history = useHistory();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
    const [listaUnidades, setListaUnidades] = useState([]);
    const [unidadSelected, setUnidadSelected] = useState(null);

    const [fechaInicio, setFechaInicio] = useState(new Date(moment().clone().startOf("week").format("YYYY-MM-DD")));
    const [fechaFin, setFechaFin] = useState(new Date(moment().clone().endOf("week").format("YYYY-MM-DD")));

    const [checklistSelected, setCheckListSelected] = useState(null);

    const [dashboardInfo, setDashboardInfo] = useState(null);
    const [listaSecciones, setListaSecciones] = useState([]);
    const [detalleChecklistSelected, setDetalleChecklistSelected] = useState([]);
    const [infoCritico, setInfoCritico] = useState(null);

    const [listaOpcionesRespuesta, setListaOpcionesRespuesta] = useState([]);

    const [infoFormulario, setInfoFormulario] = useState(null);

    const [infoFormularioPiePagina, setInfoFormularioPiePagina] = useState(null);

    const [colorMain, setColorMain] = useState(COLOR_AZUL_MAIN);

    const [btnCompartir, setBtnCompartir] = useState(false);
    const [btnVer, setBtnVer] = useState(false);
    const [btnBuscar, setBtnBuscar] = useState(false);

    const [permisos, setPermisos] = useState(null);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const unidades = await obtenerTodasLasUnidades();
            // console.log('unidades');
            // console.log(unidades);
            setListaUnidades(unidades);

            await obtenerDatosDashboard();

            const opcionesRespuesta = await obtenerListaTipoOpcionesRespuesta();
            // console.log('opcionesRespuesta');
            // console.log(opcionesRespuesta);
            setListaOpcionesRespuesta(opcionesRespuesta);


            const colorBase = localStorage.getItem(STRING_COLOR_PRIMARIO);
            if (colorBase !== null) {
                setColorMain(colorBase);
            }
            // console.log('idTipoUsuario', idTipoUsuario);
            // console.log('INT_TIPO_USUARIO_ADMINISTRADOR_WEB', INT_TIPO_USUARIO_ADMINISTRADOR_WEB);
            // console.log('String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)', String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB));
            if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
                // accesoBotonNuevo = '';
                setBtnCompartir(true);
                setBtnVer(true);
                setBtnBuscar(true);
                setTieneAccesoAlModulo(true);
            }
            if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
                const objEnviar = {
                    idSubTipoUsuarioWeb: idSubTipoUsuarioWeb,
                };
                const permisos = await obtenerPermisos(objEnviar);
                console.log('permisos');
                console.log(permisos);
                if (permisos.error === false && Array.isArray(permisos.data) && permisos.data.length > 0) {
                    setPermisos(permisos.data[0]);
                    const permisosInfo = JSON.parse(permisos.data[0].permisos);
                    // console.log('permisosInfo');
                    // console.log(permisosInfo);
                    const permisosPage = permisosInfo.find(e => e.value === PAGE_ID.DASHBOARD);
                    // console.log('permisosPage');
                    // console.log(permisosPage);
                    setTieneAccesoAlModulo(permisosPage.checked === true);
                }
            }
            setCargandoPage(false);
        } catch (err) {
            setTieneAccesoAlModulo(false);
            console.log('iniciar err');
            console.log(err);
        }
    };

    useEffect(() => {
        if (permisos !== null) {
            filtrarBotones();
            filtrarUnidades();
        }
    }, [permisos]);

    const filtrarBotones = () => {
        try {
            // console.log('filtrarData');
            // console.log(permisos);
            const parsePermisos = JSON.parse(permisos.permisos);
            // console.log('parsePermisos');
            // console.log(parsePermisos);
            const permisosDashboard = parsePermisos.find(e => e.value === PAGE_ID.DASHBOARD);
            // console.log('permisosDashboard');
            // console.log(permisosDashboard);
            if (permisosDashboard !== undefined) {
                const acciones = permisosDashboard.acciones;
                // console.log('acciones');
                // console.log(acciones);
                if (acciones !== undefined) {
                    const btnCompartir = acciones.find(e => e.value === 'btn_compartir');
                    // console.log('btnCompartir');
                    // console.log(btnCompartir);
                    if (btnCompartir !== undefined) {
                        setBtnCompartir(btnCompartir.checked);
                    }
                    const btnVer = acciones.find(e => e.value === 'btn_ver');
                    // console.log('btnVer');
                    // console.log(btnVer);
                    if (btnVer !== undefined) {
                        setBtnVer(btnVer.checked);
                    }
                    const btnBuscar = acciones.find(e => e.value === 'btn_buscar');
                    // console.log('btnBuscar');
                    // console.log(btnBuscar);
                    if (btnBuscar !== undefined) {
                        setBtnBuscar(btnBuscar.checked);
                    }
                }
            }
        } catch (err) {
            console.log('filtrarBotones err');
            console.log(err);
        }
    };

    const filtrarUnidades = () => {
        try {
            // console.log('filtrarUnidades');
            // console.log(permisos);
            const parseUnidades = JSON.parse(permisos.unidades);
            // console.log('parseUnidades');
            // console.log(parseUnidades);
            setListaUnidades(parseUnidades);
        } catch (err) {
            console.log('filtrarUnidades err');
            console.log(err);
        }
    };

    const obtenerDatosDashboard = async () => {
        try {
            let objEnviar = {};
            objEnviar.fechaInicio = moment(fechaInicio).format('YYYY-MM-DD');
            objEnviar.fechaFin = moment(fechaFin).format('YYYY-MM-DD');
            objEnviar.placa = unidadSelected !== null ? unidadSelected.value : null;
            const responseInfoDashboard = await obtenerDatosDashboardChecklist(objEnviar);
            // console.log('responseInfoDashboard');
            // console.log(responseInfoDashboard);
            setDashboardInfo(responseInfoDashboard);
        } catch (err) {
            console.log('obtenerDatosDashboard err');
            console.log(err);
        }
    };

    const handleBuscarClick = () => {
        obtenerDatosDashboard();
        setDashboardInfo(null);
        setListaSecciones([]);
        setDetalleChecklistSelected([]);
        setInfoCritico(null);
        if (Array.isArray(listaOpcionesRespuesta) === true) {
            for (let i = 0; i < listaOpcionesRespuesta.length; i++) {
                listaOpcionesRespuesta[i].count = 0;
            }
        }
    };

    const handleClickChecklist = async (item) => {
        // console.log('item');
        // console.log(item);
        setCheckListSelected(item);
        let objEnviar = {};
        objEnviar.idRespuestaChecklist = item.id;
        objEnviar.idTipoChecklist = item.idTipoChecklist;
        objEnviar.idChecklist = item.idChecklist;
        const formularioChecklist = await obtenerFormularioChecklist(objEnviar);
        // console.log('formularioChecklist');
        // console.log(formularioChecklist);

        setInfoFormulario(formularioChecklist);

        const detalleRespuesta = await obtenerDetalleRespuestaChecklist(objEnviar);
        // console.log('detalleRespuesta');
        // console.log(detalleRespuesta);
        if (Array.isArray(detalleRespuesta) === true) {
            setDetalleChecklistSelected(detalleRespuesta);
            let lista = [];
            let cantidadCritico = 0;
            for (let i = 0; i < detalleRespuesta.length; i++) {
                const element = detalleRespuesta[i];
                let obj = {};
                obj.nombreSeccion = element.nombreSeccion;
                obj.cantidad = element.preguntas.length;
                lista.push(obj);
                for (let j = 0; j < element.preguntas.length; j++) {
                    const pregunta = element.preguntas[j];
                    if (pregunta.critico === 1) {
                        cantidadCritico = cantidadCritico + 1;
                    }
                }
            }
            // console.log('lista');
            // console.log(lista);
            setListaSecciones(lista);
            setInfoCritico(cantidadCritico);
        } else {
            setListaSecciones([]);
            setDetalleChecklistSelected([]);
            setInfoCritico(null);
        }
        const formularioPieDePagina = await obtenerFormularioPieDePagina(objEnviar);
        // console.log('formularioPieDePagina', formularioPieDePagina);
        setInfoFormularioPiePagina(formularioPieDePagina);
    };

    const renderDashboardInfo = () => {
        try {
            if (dashboardInfo.listaChecklist.length === 0) {
                return (
                    <label className="text-white p-2">NO DATA</label>
                );
            }
            let listaChecklist = [];
            if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
                // console.log('dashboardInfo no filtrar listaChecklist');
                listaChecklist = dashboardInfo.listaChecklist;
            }
            if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
                // console.log('dashboardInfo filtrar listaChecklist');
                // console.log('listaUnidades');
                // console.log(listaUnidades);
                dashboardInfo.listaChecklist.forEach(item => {
                    // console.log('item');
                    // console.log(item);
                    if (item.valueVehiculo === "" || listaUnidades.some(e => e.value === item.valueVehiculo)) {
                        // console.log('item agregar listaChecklist');
                        // console.log(item);
                        listaChecklist.push(item);
                    }
                });
            }
            return (
                <div className="checklist-container">
                    {listaChecklist.map((item) => (
                        <div key={item.id}
                            className="checklist-item border-b p-2 cursor-pointer hover:bg-gray-200 transition duration-200 flex direction-row items-center"
                            onClick={() => {
                                handleClickChecklist(item);
                            }}
                            title={t('label_ver_detalles') + ': ' + item.labelVehiculo}
                        >
                            <div className="w-[90%]">
                                <h3 className="font-bold text-lg">{item.nombreChecklist}</h3>
                                <p>{t('label_vehiculo')}: {item.labelVehiculo || 'N/A'}</p>
                                <p>{t('label_fecha_registro')}: {moment(item.fechaRegistro).format("DD/MM/YYYY HH:mm")}</p>
                            </div>
                            {btnCompartir === true && (
                                <div
                                    className="w-[10%]"
                                    title="Compartir"
                                    onClick={() => { handleShareClick(item); }}
                                >
                                    <ShareIcon
                                        width={24}
                                        height={24}
                                        className="transition-all duration-300 ease-in-out hover:scale-125 hover:text-blue-500"
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            );
        } catch (err) {
            console.log("renderDashboardInfo err");
            console.log(err);
            return (<div>
                NO DATA
            </div>);
        }
    };

    const handleShareClick = (item) => {
        // console.log('item');
        // console.log(item);
        const idEmpresa = localStorage.getItem(STRING_ID_EMPRESA_CHECKLIST);
        const url = `https://checklist.boltrack.net/externo/${item.id}/${idEmpresa}`;
        // console.log('url');
        // console.log(url);
        navigator.clipboard.writeText(url);
        alert(t('alert_url_copiada_al_portapapeles'));
    };

    const renderListaSecciones = () => {
        try {
            if (listaSecciones.length > 0) {
                return (
                    <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12 overflow-x-auto">
                        <label className="font-bold text-lg">{t('label_secciones')}</label>
                        <div className="flex space-x-4 ">
                            {listaSecciones.map((item) => (
                                <div
                                    key={item.id}
                                    className="checklist-item border-b p-2 bg-gray-400"
                                >
                                    <h3 className="font-bold text-lg">
                                        {item.nombreSeccion}: {item.cantidad}
                                    </h3>
                                </div>
                            ))}
                        </div>
                    </div>
                );

            }
            return null;
        } catch (err) {
            console.log('renderListaSecciones err');
            console.log(err);
        }
    };

    const renderInfoCritico = () => {
        try {
            if (infoCritico !== null) {
                return (
                    <>
                        <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                            <label className="font-bold text-lg">{t('label_critico')}:{infoCritico}</label>
                        </div>
                        <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6 flex justify-end">
                            {btnVer === true && (
                                <button
                                    type="button"
                                    className={ESTILO_BOTON_LISTAR_NUEVO}
                                    onClick={() => {
                                        // console.log('checklistSelected');
                                        // console.log(checklistSelected);
                                        sharedNextPage("dashboard/detalle-checklist", checklistSelected, history);
                                    }}
                                    style={{
                                        backgroundColor: colorMain,
                                    }}
                                    title="Ver"
                                >
                                    <ExternalLink />
                                </button>
                            )}
                        </div>
                    </>
                );
            }
            return null;
        } catch (err) {
            console.log('renderInfoCritico err');
            console.log(err);
        }
    };

    const renderDetalleChecklistSelected = () => {
        // console.log('renderDetalleChecklistSelected');
        // console.log(detalleChecklistSelected);
        // console.log('checklistSelected');
        // console.log(checklistSelected);
        // if (detalleChecklistSelected.length > 0) {
        return (
            <ComponentDetalleChecklist
                detalleChecklist={detalleChecklistSelected}
                infoFormulario={infoFormulario}
                formularioPieDePagina={infoFormularioPiePagina}
                showFooter={true}
            />
        );
        // }
        // return null;
    };

    const renderPieChart = () => {
        try {
            // console.log('renderPieChart');
            // console.log(detalleChecklistSelected);
            if (infoCritico === null) return null;
            // console.log(listaOpcionesRespuesta);
            let lista = [];
            // debugger;
            for (let i = 0; i < detalleChecklistSelected.length; i++) {
                const seccion = detalleChecklistSelected[i];
                for (let j = 0; j < seccion.preguntas.length; j++) {
                    const pregunta = seccion.preguntas[j];
                    // console.log('pregunta');
                    // console.log(pregunta);
                    if (pregunta.idTipoPregunta === INT_PREGUNTA_SELECCION_SIMPLE) {
                        let objPie = {};
                        objPie.label = pregunta.labelOpcionRespuesta;
                        objPie.idOpcionRespuesta = pregunta.idOpcionRespuesta;
                        const color = listaOpcionesRespuesta.find(e => e.id === pregunta.idOpcionRespuesta);
                        if (color !== undefined) {
                            objPie.color = color.color;
                        } else {
                            // console.log('pregunta');
                            // console.log(pregunta);
                            // console.log('color');
                            // console.log(color);
                            // console.log('i');
                            // console.log(i);
                            objPie.color = '#0F3457';
                        }

                        objPie.count = 1;
                        if (lista.length === 0) {
                            lista.push(objPie);
                        } else {
                            const index = lista.findIndex(e => parseInt(e.idOpcionRespuesta) === parseInt(pregunta.idOpcionRespuesta));
                            if (index === -1) {
                                lista.push(objPie);
                            }
                            if (index !== -1) {
                                lista[index].count = lista[index].count + 1;
                            }
                        }
                    }
                }
            }
            // console.log('lista');
            // console.log(lista);
            const labelsArray = lista.map(item => item.label);
            // console.log('labelsArray');
            // console.log(labelsArray);
            const dataArray = lista.map(item => item.count);
            // console.log('dataArray');
            // console.log(dataArray);
            const colorArray = lista.map(item => item.color);
            // console.log('colorArray');
            // console.log(colorArray);
            const dataPieChart = {
                labels: labelsArray,
                datasets: [
                    {
                        label: 'Cantidad',
                        data: dataArray,
                        backgroundColor: colorArray,
                        borderColor: colorArray,
                        borderWidth: 1,
                    },
                ],
            };
            return (
                <div ref={pieRespuestasRef} >
                    <div className="flex justify-between">
                        <label className="font-bold text-lg">{t('titulo_opciones_respuesta_seleccionadas')}</label>
                        <PrinterIcon width={24} height={24} title="Exportar Grafico" onClick={() => { exportarPieRespuestas(); }} />
                    </div>
                    <div className="flex row pt-4">
                        <div style={{ width: '50%' }}>
                            <Pie data={dataPieChart} />
                        </div>
                        <div style={{ width: '50%' }}>
                            {lista.map((item) => (
                                <div key={item.idOpcionRespuesta} className="flex items-center mb-2">
                                    <div
                                        style={{
                                            width: '58px',
                                            height: '18px',
                                            backgroundColor: item.color,
                                        }}
                                        className="mr-2"
                                    ></div>
                                    <span>{item.label}:{item.count}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            );
        } catch (err) {
            console.log('renderPieChart err');
            console.log(err);
        }
    };

    const exportarPieRespuestas = () => {
        try {
            // console.log('exportarPieRespuestas');
            const content = pieRespuestasRef.current;
            const options = {
                filename: 'respuestas.pdf',
                margin: 1,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: {
                    unit: 'in',
                    format: 'letter',
                    orientation: 'portrait',
                },
            };
            html2pdf().set(options).from(content).save();
        } catch (err) {
            console.log('renderPieChart err');
            console.log(err);
        }
    };

    const renderVehiclesChart = () => {
        try {
            // console.log('dashboardInfo');
            // console.log(dashboardInfo);
            // listaUnidades.forEach(item => {
            //     console.log('valueVehiculo:', item.valueVehiculo);
            // });

            const uniqueValues = [...new Set(dashboardInfo.listaChecklist.map(item => item.valueVehiculo))];
            // console.log('uniqueValues');
            // console.log(uniqueValues);
            const listaPlacas = [...new Set(listaUnidades.map(item => item.value))];
            // console.log('listaPlacas');
            // console.log(listaPlacas);
            const filteredArray = listaPlacas.filter(item => !uniqueValues.includes(item));
            // console.log('filteredArray');
            // console.log(filteredArray);
            const labelsArray = [t('titulo_vehiculos_sin_checklist'), t('titulo_vehiculos_con_checklist')];
            const dataArray = [filteredArray.length, uniqueValues.length];
            const colorArray = ['#d43224', '#42d624']
            const dataPieChart = {
                labels: labelsArray,
                datasets: [
                    {
                        label: 'Checklist',
                        data: dataArray,
                        backgroundColor: colorArray,
                        borderColor: colorArray,
                        borderWidth: 1,
                    },
                ],
            };
            let listaInfo = [];
            let objSinChecklist = {};
            objSinChecklist.label = t('titulo_sin_checklist');
            objSinChecklist.count = filteredArray.length;
            objSinChecklist.color = '#d43224';
            listaInfo.push(objSinChecklist);

            let objConChecklist = {};
            objConChecklist.label = t('titulo_con_checklist');
            objConChecklist.count = uniqueValues.length;
            objConChecklist.color = '#42d624';
            listaInfo.push(objConChecklist);
            return (
                <div ref={unidadesRef}>
                    <div className="flex justify-between">
                        <label className="font-bold text-lg">{t('titulo_vehiculos_que_realizaron_checklist')}</label>
                        <PrinterIcon width={24} height={24} title={t('titulo_exportar_grafico')} onClick={() => { exportarPieUnidades(); }} />
                    </div>
                    <div className="flex row pt-4">
                        <div style={{ width: '50%' }}>
                            <Pie data={dataPieChart} />
                        </div>
                        <div style={{ width: '50%' }}>
                            {listaInfo.map((item) => (
                                <div key={shortid.generate()} className="flex items-center mb-2">
                                    <div
                                        style={{
                                            width: '58px',
                                            height: '18px',
                                            backgroundColor: item.color,
                                        }}
                                        className="mr-2"
                                    ></div>
                                    <span>{item.label}:{item.count}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            );
        } catch (err) {
            console.log('renderVehiclesChart err');
            console.log(err);
        }
    };

    const exportarPieUnidades = () => {
        try {
            const content = unidadesRef.current;
            const options = {
                filename: 'unidades.pdf',
                margin: 1,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: {
                    unit: 'in',
                    format: 'letter',
                    orientation: 'portrait',
                },
            };
            html2pdf().set(options).from(content).save();
        } catch (err) {
            console.log('exportarPieUnidades err');
            console.log(err);
        }
    };

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (tieneAccesoAlModulo === false) {
                return SinAccesoCard();
            }
            return (
                <div className="m-4">
                    <div className="grid grid-cols-12 gap-4">

                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <label>{t('label_seleccione_unidad')}</label>
                            <Select
                                options={listaUnidades}
                                value={unidadSelected}
                                onChange={(e) => {
                                    setUnidadSelected(e);
                                }}
                                isClearable={true}
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <label>{t('label_fecha_inicio')}</label>
                            <DatePicker
                                defaultValue={fechaInicio}
                                value={fechaInicio}
                                valueFormat={{ dateStyle: "medium" }}
                                onChange={(date) => setFechaInicio(date)}
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <label>{t('label_fecha_fin')}</label>
                            <DatePicker
                                defaultValue={fechaFin}
                                value={fechaFin}
                                valueFormat={{ dateStyle: "medium" }}
                                onChange={(date) => setFechaFin(date)}
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3"
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                            }}
                        >
                            {btnBuscar === true && (
                                <button
                                    className={`${ESTILO_BOTON_LISTAR_NUEVO}`}
                                    type="button"
                                    onClick={handleBuscarClick}
                                    style={{ backgroundColor: colorMain }}
                                >
                                    {t('btn_buscar')}
                                </button>
                            )}
                        </div>

                        <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12 bg-gray-700 p-2">
                            <div className="flex justify-between">
                                <label className="text-white">{t('label_cantidad')}: {dashboardInfo !== null && dashboardInfo.cantidad !== undefined ? dashboardInfo.cantidad : ""}</label>
                                <label className="text-white">{t('label_total_critico')}: {dashboardInfo !== null && dashboardInfo.critico !== undefined ? dashboardInfo.critico : ""}</label>
                            </div>
                        </div>

                        {renderListaSecciones()}

                        {renderInfoCritico()}

                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span- bg-gray-400" style={{ maxHeight: '512px', overflow: 'auto' }}>
                            {dashboardInfo !== null && dashboardInfo.listaChecklist !== undefined && Array.isArray(dashboardInfo.listaChecklist) === true &&
                                <>
                                    {renderDashboardInfo()}
                                </>
                            }
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-9 xl:col-span-9" style={{ maxHeight: '512px', overflow: 'auto' }}>
                            {renderDetalleChecklistSelected()}
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-4">

                        <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                            {renderVehiclesChart()}
                        </div>
                        <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                            {renderPieChart()}
                        </div>

                    </div>
                </div>
            );
        } catch (err) {
            console.log('render err dashboard');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    };


    return render();
};
